module.exports = __webpack_public_path__ + "img/newyear_btn_submit.840322b5.png";